import { useMemo } from "react";
const approverRequiredBanks = ["icici"];
export const useRequiresApproverDetails = (
  bidderData: any,
  kycMode: string,
): boolean => {
  return useMemo(() => {
    if (kycMode !== "offline") {
      return false;
    }
    const bankName = String(
      bidderData?.meta?.bank_name ||
        bidderData?.meta?.bank_details?.bank_name ||
        "",
    )
      .trim()
      .toLowerCase();
    if (!bankName) {
      return false;
    }
    return approverRequiredBanks.some((bank) => bankName.includes(bank));
  }, [bidderData, kycMode]);
};
